export default {
  unit: {
    input_hint: 'Vous pouvez exprimer votre réponse dans une autre unité'
  },
  errors: {
    conversionFailed: 'La conversion a échoué. Veuillez essayer avec une autre unité.'
  }
}
